import React, { PropsWithChildren, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { SessionContext } from 'src/business/context/session-context';

export const ProtectedAuthOnlyRoute = (params: PropsWithChildren<any>): React.ReactElement => {
	const { children } = params;
	const { isLoggedIn } = useContext(SessionContext);
	return isLoggedIn ? children : <Navigate to="/login" />;
};
